<template>
  <!-- 独立 AI 对话弹窗：首页「发布消息」/底部「+」/Onboarding 结束/草稿续写 banner 的统一入口。
       复用 ChatBox（不传 channelId = 独立会话，发布走选群/建群流程），
       与群内 AI 聊天弹窗（ChannelDetail）同一交互形态，替代原 /ai 独立页。
       挂载在 App.vue 全局，经 store.showAiChatPopup 开关控制；ChatBox 用 v-if 惰性创建，关闭即销毁 -->
  <van-popup :value="$store.state.showAiChatPopup" round position="bottom" :style="{ height: '90%' }"
    @close="close" @click-overlay="close">
    <div class="ai-chat-popup">
      <div class="ai-chat-popup-header">
        <van-icon name="cross" size="20" color="#4A4A4A" @click="close" />
        <span></span>
      </div>
      <div class="ai-chat-popup-body">
        <ChatBox v-if="$store.state.showAiChatPopup"
          :standalone="true"
          :currentAvatarUrl="$store.state.user && ($store.state.user.avatar || $store.state.user.avatarUrl)"
          :currentUserName="$store.state.user && ($store.state.user.userName || $store.state.user.username || $store.state.user.name || ($store.state.user.email ? $store.state.user.email.split('@')[0] : '')) || $t('default_username')"
          :chatMsgListStyle="{ minHeight: '0', maxHeight: 'none', backgroundColor: '#ECEAE6', padding: '12px' }" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import ChatBox from './ChatBox'

export default {
  name: 'AiChatPopup',
  components: {
    'ChatBox': ChatBox
  },
  methods: {
    close () {
      this.$store.commit('setShowAiChatPopup', false)
    }
  }
}
</script>

<style scoped>
.ai-chat-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ECEAE6;
}

.ai-chat-popup-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  flex-shrink: 0;
}

.ai-chat-popup-body {
  flex: 1;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/AiChatPopup.vue